const updateChildren = (state, action) => {
  if (state === undefined) {
    return {
      children: [],
      loading: false,
      child_id: null,
      child: null,
      error: null,
      status_children: [],
    };
  }

  switch (action.type) {
    case "CHILDREN_REQUEST":
      return {
        ...state.children,
        children: action.payload,
        loading: false,
        error: null,
      };

    case "CHILD_REQUEST":
      return {
        ...state.children,
        child: action.payload,
        loading: false,
        error: null,
      };
    case "CHILDREN_LOADING":
      return {
        ...state.children,
        loading: true,
      };
    case "UPDATE_CHILD":
      return {
        ...state.children,
        error: null,
        child: action.payload,
        loading: false,
      };

    case "CHILD_ID":
      return {
        ...state.children,
        child_id: action.payload,
      };
    case "STATE_STATUS_CHILDREN":
      return {
        ...state.children,
        status_children: action.payload,
      };
    default:
      return state.children;
  }
};

export default updateChildren;
